import taverneuUrl from "../assets/perso/taverneu_1.png";
import type { TaverneuLine } from "../game/taverneu";

const DISPLAY_MS = 5400;

/** Bulle de dialogue du Taverneu (portrait + parchemin), en coin d'ecran, qui se referme seule apres un delai. */
export class TaverneuBubble {
  private readonly el: HTMLDivElement;
  private hideTimer: number | null = null;

  constructor(root: HTMLElement) {
    this.el = document.createElement("div");
    this.el.id = "taverneu-bubble";
    this.el.innerHTML = `
      <div class="taverneu-scroll"><p id="taverneu-speech-text"></p></div>
      <svg class="taverneu-tail" viewBox="0 0 20 18" aria-hidden="true">
        <path d="M0 0 L20 0 L20 18 Z" />
      </svg>
      <div class="taverneu-portrait">
        <div class="taverneu-figure"><img src="${taverneuUrl}" alt="Le Taverneu" /></div>
      </div>
    `;
    root.appendChild(this.el);
    // Clic sur la bulle = fermeture manuelle immediate, sans attendre le delai d'auto-fermeture.
    this.el.addEventListener("click", () => this.hide());
  }

  /**
   * `persistent` (tuto scenarise) : n'arme pas la fermeture automatique — la
   * bulle reste affichee tant que hide()/say() ne sont pas rappeles, le joueur
   * avancant lui-meme via Precedent/Suivant plutot que sur un delai fixe.
   */
  say(line: Pick<TaverneuLine, "text">, options?: { persistent?: boolean }): void {
    const textEl = this.el.querySelector<HTMLElement>("#taverneu-speech-text")!;
    textEl.textContent = line.text;
    // Repart de zero pour rejouer l'entree (figure puis texte, decales) meme si la
    // bulle precedente etait encore visible ou en train de disparaitre.
    this.el.classList.remove("visible", "hiding");
    void this.el.offsetWidth;
    this.el.classList.add("visible");
    if (this.hideTimer !== null) {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    if (!options?.persistent) {
      this.hideTimer = window.setTimeout(() => this.hide(), DISPLAY_MS);
    }
  }

  /** Referme la bulle (ex: une modale s'ouvre par-dessus, ou le delai normal expire) : fondu vers le bas. */
  hide(): void {
    if (this.hideTimer !== null) {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.el.classList.remove("visible");
    this.el.classList.add("hiding");
  }

  destroy(): void {
    if (this.hideTimer !== null) window.clearTimeout(this.hideTimer);
    this.el.remove();
  }
}
